import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CssBaseline, GlobalStyles } from '@mui/material';
import './i18n';
import './assets/fonts/inter/Inter-VariableFont_opsz,wght.ttf';
import './assets/fonts/inter/Inter-Italic-VariableFont_opsz,wght.ttf';
import './assets/fonts/cal-sans/CalSans-Regular.ttf';
import { ThemeProviderContext } from './theme/context/themeProviderContext';

const globalStyles = (
  <GlobalStyles
    styles={{
      'html,body,#root,.App': {
        width: '100%',
        height: '100%',
      },
      '#root': {
        display: 'flex',
      },
    }}
  />
);

const Index = () => {
  return (
    <ThemeProviderContext>
      <CssBaseline />
      {globalStyles}
      <App />
    </ThemeProviderContext>
  );
};

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/serviceworker.js');
}

async function bootstrap() {

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );
  root.render(
    <Index />,
  );
}

bootstrap();

